import { call, put, all, takeEvery } from "redux-saga/effects";
import {
  FETCH_MENU
} from "./actionTypes"
import {
  fetchMenuSuccess
} from "./actions";

import { makeAjax, url, showMessage } from "../../helpers/global_helper";
import { USER_MS_EXT } from "../../helpers/url_helper";

function* fetchMenu() {
  try {
    
    const response = yield call(
      makeAjax,
      url.USER_API.listUserMenu,
      {},
      USER_MS_EXT
    );
    if (response.status == 'SUCCESS') {
      yield all([
        put(fetchMenuSuccess({ response: response.data }))
      ]);
    }
    else {
      showMessage(response);
    }
  } catch (error) {
    showMessage(error);
    
    // alert
  }
}

function* menuListSaga() {
  yield takeEvery(FETCH_MENU, fetchMenu);
}

export default menuListSaga;
